import { render } from "./Widget6.vue?vue&type=template&id=7ab05114"
import script from "./Widget6.vue?vue&type=script&lang=js"
export * from "./Widget6.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__